import type { GeneralTranslation } from "@swo/storefront";
import { pipe } from "fp-ts/lib/function";
import { nonEmptyArray as NEA } from "fp-ts";
import type React from "react";
import { Spacer } from "../../components/_shared-components/arrangement/Space";
import type { HeaderPinnedState } from "../../components/HeaderComponent/subcomponents/use-header-pinned-state";
import { enrichedSwarovskiProductFrontendOrd } from "../../domain/swarovski-optik/products/ord";
import type { Translated } from "../../domain/translations/translations";
import { usePageLocaleContext } from "../../global/page-context";
import { getSections } from "./getSections";
import { OtherProductsInFamily } from "./other-products-in-family";
import { PDPSectionsWithNavigation } from "./pdp-navigation";
import type { PDPState } from "./PDP_SingleImageCarousel/availability/use-product-variant-state";
import type { PDPMainComponentProps } from "./PDPMainComponent";
import { usePdpTranslations } from "./PdpTranslationsContext";
import type { ReviewTranslations } from "./reviewTranslations";

export const PDPBelowTheFoldLayout_Product: React.FC<
  React.PropsWithChildren<{
    pdpState: PDPState;
    data: PDPMainComponentProps["data"];
    gt: Translated<GeneralTranslation>;
    reviewsT: ReviewTranslations;
    primaryButton: React.JSX.Element;
    headerState: HeaderPinnedState;
  }>
> = ({ pdpState, data, gt, reviewsT, primaryButton, headerState, children }) => {
  const t = usePdpTranslations();
  const { locale } = usePageLocaleContext();

  const familyProducts = pipe(data.familyProducts, NEA.sort(enrichedSwarovskiProductFrontendOrd));

  const sections = getSections(pdpState, data, { t, gt, reviewsT }, locale);

  return (
    <>
      <OtherProductsInFamily
        headline={t("productSelectionLabel")}
        products={familyProducts}
        selectedProductKey={pdpState.selectedProduct.key}
        centeredIfNotFilled={false}
      />

      <PDPSectionsWithNavigation headerState={headerState} Button={primaryButton} sections={sections}>
        <Spacer size={"lg"} />

        {children}
      </PDPSectionsWithNavigation>
    </>
  );
};
